import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fl mt20 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_chat_`,
  class: "fs13"
}, "チャットを設置", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "grey fs12" }, [
  /*#__PURE__*/_createTextVNode(" お相手はいつでも公開ページ上で問い合わせすることができるようになります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※問い合わせ時にメールアドレスとお名前の入力は必須 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CheckboxTag, {
      value: ``,
      name: `use_chat`,
      checked: _ctx.rcm.room_setting.use_chat,
      prefix: `use_chat`,
      onClickCheckbox: _ctx.clickUseChat,
      style: {"margin-left":"1px","margin-right":"7px"}
    }, null, 8, ["checked", "onClickCheckbox"]),
    _hoisted_2,
    _hoisted_3
  ]))
}